import { useNavigate } from "react-router-dom";
import { Lock, Crown, Zap } from "lucide-react";
import { useSubscription } from "../context/SubscriptionContext";

export default function SubscriptionGate({ children }) {
  const { isSubscribed, loading } = useSubscription();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-pulse text-muted-foreground">Chargement...</div>
      </div>
    );
  }

  if (isSubscribed) {
    return children;
  }

  return (
    <div className="relative" data-testid="locked-overlay">
      {/* Blurred background content */}
      <div className="pointer-events-none select-none filter blur-[6px] opacity-40">
        {children}
      </div>

      {/* Lock overlay */}
      <div className="absolute inset-0 flex items-center justify-center z-10">
        <div className="neo-card p-10 max-w-md text-center border-[#00E676] bg-white dark:bg-[#0A0A0A]" data-testid="paywall-card">
          <div className="mx-auto w-20 h-20 bg-[#0A0A0A] dark:bg-[#00E676] border-4 border-[#0A0A0A] flex items-center justify-center mb-6">
            <Lock size={36} className="text-[#00E676] dark:text-[#0A0A0A]" />
          </div>
          <h2 className="text-2xl font-extrabold mb-2">Contenu réservé aux abonnés</h2>
          <p className="text-muted-foreground mb-6">
            Abonnez-vous à Profimy Pro pour débloquer toutes les fonctionnalités avancées.
          </p>
          <div className="flex items-baseline justify-center gap-1 mb-6">
            <span className="text-4xl font-extrabold">19</span>
            <span className="text-xl font-bold">€</span>
            <span className="text-muted-foreground">/mois</span>
          </div>
          <button
            onClick={() => navigate("/subscription")}
            className="neo-button-primary w-full flex items-center justify-center gap-2 text-lg py-3"
            data-testid="unlock-btn"
          >
            <Zap size={20} />
            Débloquer l'accès — 19€/mois
          </button>
          <p className="text-xs text-muted-foreground mt-3">
            Sans engagement — Annulable à tout moment
          </p>
        </div>
      </div>
    </div>
  );
}
